import React, { useState } from "react";
import apiClient from "../../service/ApiClient";

export function MultipleFileUploader({
  label,
  onUploadComplete,
  uploadingText = "Uploading...",
  t = (key) => key,
}) {
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setIsUploading(true);
    const keys = [];
    try {
      for (const file of files) {
        const resp = await apiClient.get(
          `/s3/presigned-url?filename=${encodeURIComponent(file.name)}`
        );
        const { url, key } = resp.data;
        const uploadRes = await fetch(url, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file,
        });
        if (!uploadRes.ok) {
          throw new Error(`Upload failed with status ${uploadRes.status}`);
        }
        keys.push(key);
      }
      onUploadComplete(keys);
    } catch (err) {
      console.error("File upload error:", err);
      alert(t("uploadError"));
      onUploadComplete([]);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        type="file"
        accept="image/*"
        multiple
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 border border-gray-300 rounded-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        onChange={handleChange}
        disabled={isUploading}
      />
      {isUploading && (
        <div className="mt-2 flex items-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          <span className="ml-2 text-sm text-gray-600">{t(uploadingText)}</span>
        </div>
      )}
    </div>
  );
}
